<template>
  <div class="stripe-operation">
    <Button :loading="loading" size="large" variant="purple" @click="handlePayClick">
      {{ loading ? $t('chuang-jian-zhong') : $t('qu-zhi-fu') }}
    </Button>
  </div>
</template>

<script setup lang="ts">
import Button from '@rendora/design/components/button/Button.vue';

const props = defineProps<{
  url?: string;
  loading: boolean;
}>();

const handlePayClick = () => {
  if (props.loading || !props.url) {
    return;
  }
  location.href = props.url;
};
</script>

<style lang="scss" scoped>
.stripe-operation {
  display: block;
  margin: 20px auto;
  > button {
    display: inline-block;
    min-width: 100px;
    margin: 0 8px;
  }
}
</style>
